/**
 * Condições do Personagem: tudo o que acontece COM a ficha — as condições primárias
 * (Vigor, Concentração, Carga, Energia, a dormida, o descanso), as do corpo (Envenenado,
 * Fome, Frio, Cansaço) e as de combate — as duas listas, todas: as quatro do Theo
 * (Atordoado, Caído, Paralisado, Furioso), as das Mecânicas (Agarrado, Amedrontado,
 * Impedido/Preso) e as seis do motor, cada uma com a escada de cinco tiers.
 *
 * <p>Saiu da página Personagem a pedido do Theo (19/08/2026): a ficha numa página, o que
 * acontece com ela noutra. Três macro-títulos e um índice clicável no alto; os títulos
 * dos quadros são editáveis, e o que não tem desenho ainda vem com os campos em branco
 * para o Theo preencher.
 *
 * <p>Duas abas, dois documentos ({@link PaginaEmDuasAbas}). A Fome mora na Season 2+ —
 * decisão do Theo, 19/08/2026.
 */
import {
  GRUPOS,
  GRUPOS_S2,
  SECOES,
  SECOES_S2,
  TABELAS,
  TABELAS_S2,
} from './conteudoDeCondicoes';
import { PaginaEmDuasAbas } from './PaginaEmDuasAbas';
import { PAGINAS } from './rascunhoDeGameDesign';

export function CondicoesDoPersonagem() {
  return (
    <PaginaEmDuasAbas
      beta={{
        chave: PAGINAS.condicoesDoPersonagem,
        tabelas: TABELAS,
        secoes: SECOES,
        grupos: GRUPOS,
        subtitulo:
          'O que acontece com a ficha: as condições primárias, as do corpo e as de combate — até a Season 1.',
      }}
      season2={{
        chave: PAGINAS.condicoesDoPersonagemSeason2,
        tabelas: TABELAS_S2,
        secoes: SECOES_S2,
        grupos: GRUPOS_S2,
        subtitulo: 'As condições que ficaram para depois da Season 1.',
      }}
    />
  );
}
